import request from "../../../utils/request";

export const getUploadToken = (params) => {
  return request({
    method: "POST",
    path: "/tool-management/getUploadToken",
    params,
  });
};

// 列表
export const getWeekActiveList = (params) => {
  return request({
    method: "GET",
    path: "/admin-management/getWeekActiveList",
    params,
  });
};

// 创建周活动
export const createWeekActive = (params) => {
  return request({
    method: "POST",
    path: "/admin-management/createWeekActive",
    params,
  });
};